import React from "react";
import ProgressBar from "./ProgressBar";

interface WeeklyAnalyticsItemProps {
    primaryText?: string;
    siteValue?: number;
    leagueValue?: number;
}

const WeeklyAnalyticsItem: React.FC<WeeklyAnalyticsItemProps> = ({
    primaryText,
    siteValue,
    leagueValue,
}) => {
    console.log(siteValue);
    return (
        <>
            <div className="mt-2">
                {primaryText ? (
                    <>
                        {primaryText} <small>(Site-wide)</small>
                    </>
                ) : (
                    <>Site-wide:</>
                )}{" "}
                <b>
                    {siteValue}
                    {siteValue !== undefined && siteValue !== null ? "%" : "-"}
                </b>
                {siteValue !== undefined && siteValue !== null ? (
                    <ProgressBar color="#a855f7" value={siteValue} />
                ) : null}
            </div>
            <div className="mt-2">
                {primaryText ? (
                    <>
                        {primaryText} <small>(League-wide)</small>
                    </>
                ) : (
                    <>League-wide:</>
                )}{" "}
                <b>
                    {leagueValue}
                    {leagueValue !== undefined && leagueValue !== null
                        ? "%"
                        : "-"}
                </b>
                {leagueValue !== undefined && leagueValue !== null ? (
                    <ProgressBar color="#28A745" value={leagueValue} />
                ) : null}
            </div>
        </>
    );
};

export default WeeklyAnalyticsItem;
